<!--订单详情-->
<template>
  <div class="wrap">
    <OrderDetailHeader
      :orderData="order"
      :payShow="payDialogShow"
      @payShowClose="payShowClose"
      @payShowSuccess="payShowSuccess"
      @payShowError="payShowError"
    ></OrderDetailHeader>

    <div class="container_wrap row-box">
      <!-- <div class="row-title temp" v-if="order.open_seller_fenxiao == 2">
        <img
          class="row-title-img"
          src="../../../static/images/dianpu.png"
          alt=""
        />
        {{ order.business_name }}
        <div class="to-be-paid">
          {{ order.status_buttons.name }}
        </div>
      </div>-->
      <div class="message-title">商品信息</div>
      <div class="row-between" v-for="(goods, index) in order.items" :key="index">
        <div class="between-left">
          <img class="between-left-img" :src="goods.pic_url" alt />
          <div class="between-right">
            <div class="flex-between">
              <div class="between-left-title">{{ goods.title }}</div>

              <div class="between-left-price">
                ¥
                <span>{{ goods.goods_price }}</span>
              </div>
              <div class="between-right-num gray-light">
                <span>x</span>
                {{ goods.count }}
              </div>
            </div>
            <div class="between-left-detail gray-light">{{ goods.sku.sku_formart }}</div>
            <div class="between-sku">
              <div></div>
              <!-- <div class="jieshao">全城保价</div> -->
              <!-- <div class="between-left-price">¥{{goods.goods_price_base}}</div> -->
              <div class="between-sku-right">
                <div class="between-right-btn" @click="onExpressTrace(goods)">物流跟踪</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row-title">备注：{{ order.buyer_note }}</div>
    </div>
    <div class="container_wrap row-message">
      <div class="message-title">物流信息</div>
      <div class="message-li">
        <div class="message-left">配送方式</div>
        <div class="message-right gray-light">快递</div>
      </div>
      <div class="message-li">
        <div class="message-left">收货地址</div>
        <div class="message-right gray-light" v-if="order.address">
          <div class="address-pro">{{ order.address.address }}</div>
          <div class="address-phone">{{ order.address.name }} {{ order.address.phone }}</div>
        </div>
      </div>
      <!--<div class="message-li">
          <div class="message-left">物流单号</div>
          <div class="message-right gray-light">
              顺丰 2727172627 | <span>物流跟踪</span>
          </div>
      </div>-->
    </div>
    <div class="container_wrap row-message">
      <div class="message-title">订单信息</div>
      <div class="message-li">
        <div class="message-left">订单号</div>
        <div class="message-right gray-light">
          {{ order.code }} |
          <span>
            <button
              type="button"
              class="btn"
              v-clipboard:copy="order.code"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
            >复制</button>
          </span>
        </div>
      </div>
      <!-- <div class="message-li">
        <div class="message-left">支付方式</div>
        <div class="message-right gray-light">微信在线支付</div>
      </div> -->
      <!-- <div class="message-li">
        <div class="message-left">下单时间</div>
        <div class="message-right gray-light">
          {{order.create_time_str}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">支付时间</div>
        <div class="message-right gray-light">
          {{order.pay_time_str}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">订单价格</div>
        <div class="message-right gray-light">
          ￥{{order.order_price}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">运费</div>
        <div class="message-right gray-light">
          ￥{{order.express_price}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">优惠</div>
        <div class="message-right gray-light">
          ￥{{order.discount_price}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">改价</div>
        <div class="message-right gray-light">
          ￥{{order.fix_price}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">应付金额</div>
        <div class="message-right gray-light">
          ￥{{order.pay_price}}
        </div>
      </div>
      <div class="message-li">
        <div class="message-left">已付金额</div>
        <div class="message-right gray-light">
          ￥{{order.payed_price}}
        </div>
      </div>-->
    </div>
    <!-- <div class="end">
      <img src="../../../static/images/sj.png" alt="">
      联系卖家
    </div>-->
    <div class="container_wrap">
      <van-action-sheet
        v-model="show"
        :actions="express"
        cancel-text="取消"
        @select="onSelect"
        @cancel="onCancel"
      ></van-action-sheet>
    </div>
  </div>
</template>
<style scoped>
.wrap {
  padding-bottom: 30px;
  box-sizing: border-box;
  padding-top: 20px;
}
.end {
  margin: 20px 0 41px 0;
  text-align: center;
  color: #4a4a4a;
  font-weight: 400;
  font-size: 15px;
}
.end img {
  vertical-align: text-bottom;
  width: 20px;
  height: 20px;
}
.btn {
  font-size: 14px;
  color: #16c263;
}
.message-left {
  font-size: 14px;
}
.flex-between {
  position: relative;
}
.jieshao {
  width: 45px;
  height: 14px;
  background: #d0021b;
  border-radius: 7px;
  opacity: 0.5;
  font-size: 8px;
  color: #ffffff;
  text-align: center;
}

.wrap >>> .order-load {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.15rem 0;
  margin: 0 auto 20px auto;
  background: #fff;
      border-radius: 10px;
}

.load-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.load-img {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.2rem;
}

.order-load-title {
  font-size: 18px;
  color: #333333;
  font-weight: 600;
}

.order-load-det {
  font-size: 14px;
  color: #7b7b7b;
  margin: 0.2rem 0;
}

.between-left-title {
  width: 200px;
  font-weight: 500;
  color: #4a4a4a;
  font-size: 18px;
}

.load-btn {
  width: 1.65rem;
  height: 0.48rem;
  line-height: 0.48rem;
  background: rgba(253, 40, 64, 1);
  border-radius: 0.06rem;
  text-align: center;
  font-size: 14px;
  color: #fff;
}

.load-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.row-title-img {
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
}

.row-box {
  /* border-top: 0.1rem solid #efefef; */
}

.row-title {
  font-size: 15px;
  font-weight: 500;
  padding: 0.2rem 0.33rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  /* border-bottom: 1px solid #efefef; */
}
.temp {
  position: relative;
}
.temp .to-be-paid {
  position: absolute;
  top: 15px;
  right: 14px;
  font-size: 14px;
  color: #d0021b;
  font-weight: 400;
}
.row-between {
  padding: 0.2rem 0;
  margin: 0 0.15rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #efefef;
}

.row-between:last-of-type {
  border: none;
}

.between-left {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.between-left-img {
  /* width: 1.1rem;
    height: 1.1rem; */
  width: 0.6rem;
  height: 0.6rem;
  border-radius: 4px;
  margin-left: 0.16rem;
  margin-right: 0.2rem;
}

.between-left-price {
  color: #4a4a4a;
}
.between-left span {
  font-size: 15px;
}

.between-left-detail {
  font-size: 11px;
  /* margin: 0.1rem 0; */
}
.between-right-num {
  position: absolute;
  top: 40px;
  right: 0px;
  font-size: 10px;
  color: #9b9b9b;
}
.between-right-num span {
  font-size: 14px;
}

.between-right-btn {
  font-size: 16px;
  font-weight: 500;
  color: #16c263;
  margin-right: 0.15rem;
  margin-left: 0.3rem;
}

.between-right {
  /* display: flex;
     justify-content: flex-start;
     align-items: flex-end;*/
  /* width: 79%; */
  flex: 1;
  /*height: 1.2rem;*/
}

.between-sku {
  display: flex;
  justify-content: space-between;
}

.between-sku-right {
  display: flex;
}

.row-message {
  margin: 10px;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.05);
  /* padding: 0.2rem 0.28rem;
    border-top: 0.1rem solid #EFEFEF; */
}

.message-title {
  font-weight: 600;
  color: #333333;
  padding: 40px 0 0 40px;
  margin-bottom: 20px;
  font-size: 24px;
}

.message-li {
  display: flex;
  justify-content: space-between;
  /* padding: 0.2rem 0 0.2rem; */
  padding: 20px 40px;
  border-bottom: 1px solid #efefef;
}

.row-message .message-li:last-child {
  border: none;
}

.message-right {
  font-size: 14px;
  text-align: right;
}

.message-right span {
  color: #0076ff;
}
.container_wrap {
  width: 1240px;
  margin: 0 auto;
  box-sizing: border-box;
  box-shadow: 0px 2px 20px 0px rgb(0 0 0 / 5%);
      border-radius: 10px;
}
.row-message {
  margin-top: 10px;
}
</style>

<script>
import OrderDetailHeader from "@/components/OrderDetailHeader.vue";
import { Toast, ActionSheet } from "vant";

export default {
  name: "OrderDetail",
  components: {
    OrderDetailHeader,
    Toast,
    [ActionSheet.name]: ActionSheet
  },
  data: function() {
    return {
      orderId: 0,
      order: {},
      /*payDialogShow: true,
        orderIds:0*/
      payDialogShow: false,
      show: false,
      express: []
    };
  },
  filter: {},
  mounted() {
    document.title = "订单详情";

    this.getOrderDetail();
  },
  destroyed() {},
  methods: {
    getOrderDetail() {
      let that = this;
      let id = (that.orderId = this.$route.query.id);

      this.$api.get("/api/order/orderDetail", { id: id }, res => {
        that.order = res.data;
      });
      // console.log(id)
    },

    // 订单评价
    onOrderComment(goods_id) {
      let that = this;
      rbLink({
        name: "OrderCommentOperate",
        query: {
          id: goods_id,
          order_id: that.orderId
        }
      });
    },

    // 物流跟踪
    onExpressTrace(goods) {
      let that = this;
      if (goods.express_list.length > 1) {
        that.show = true;

        goods.express_list.map(express => {
          express.name = express.company_name + "(" + express.num + ")";
        });

        that.express = goods.express_list;
      } else if (goods.express_list.length == 1) {
        rbLink({
          name: "ExpressTrace",
          query: { id: goods.express_list[0].id }
        });
      } else {
        Toast("暂无物流信息");
      }
    },

    onSelect(item) {
      rbLink({
        name: "ExpressTrace",
        query: { id: item.id }
      });
    },

    onCancel() {
      console.log("onCancel");
    },

    // 复制订单号
    onCopy(e) {
      Toast.success("复制成功");
    },
    onError(e) {
      console.log("复制失败！");
    },

    payShowError() {
      this.payDialogShow = false;
    },

    payShowSuccess() {
      this.payDialogShow = true;
      // console.log(data);
    },

    payShowClose() {
      this.payDialogShow = false;
      this.getOrderDetail();
    }
  }
};
</script>



// WEBPACK FOOTER //
// OrderDetail.vue?334c5a9a